<template>
  <unicom-layout-cartao semFiltro>
    <unicom-linha class="linha-embaixo">
      <unicom-coluna sm="12" style="padding-bottom: 24px">
        <div class="titulo negrito cor-fonte fonte-primaria">
          Dados Complementares do Diretor/Responsável Técnico
        </div>
      </unicom-coluna>
    </unicom-linha>

    <unicom-linha
      key="informacoes"
      style="min-height: 76px"
      justificarItem="between"
    >
      <unicom-coluna sm="3" :class="espacamentoMobile">
        <div class="segunda-cor-fonte">Nome do Diretor Técnico:</div>
        <div class="mt-3">
          {{ direcaoLideranca.nomeDiretorTecnico }}
        </div>
      </unicom-coluna>
      <unicom-coluna sm="3" :class="espacamentoMobile">
        <div class="segunda-cor-fonte">Sigla do Conselho:</div>
        <div class="mt-3">
          {{ direcaoLideranca.conselho }}
        </div>
      </unicom-coluna>
      <unicom-coluna sm="3" :class="espacamentoMobile">
        <div class="segunda-cor-fonte">Registro do Conselho:</div>
        <div class="mt-3">
          {{ direcaoLideranca.registroConselho }}
        </div>
      </unicom-coluna>
      <unicom-coluna sm="3" :class="espacamentoMobile">
        <div class="segunda-cor-fonte">UF do Conselho:</div>
        <div class="mt-3">
          {{ direcaoLideranca.ufConselho }}
        </div>
      </unicom-coluna>
    </unicom-linha>

    <unicom-linha style="min-height: 76px">
      <unicom-coluna sm="6" :class="espacamentoMobile">
        <unicom-campo-texto
          v-model="diretorTecnico.email"
          :icone="diretorTecnico.email ? 'x' : ''"
          :mensagemErro="errors.email"
          @click-icone="diretorTecnico.email = ''"
          @input="validate('email')"
          maxCaracteres="50"
          ladoIcone="direito"
          clickIcone
          colorPlaceholder="#9E9E9E"
          placeholder="E-mail"
          titulo="E-mail *"
          type="email"
        />
      </unicom-coluna>
      <unicom-coluna sm="3" :class="espacamentoMobile">
        <unicom-campo-texto
          v-model="diretorTecnico.formacao"
          :icone="diretorTecnico.formacao ? 'x' : ''"
          :mensagemErro="errors.formacao"
          @click-icone="diretorTecnico.formacao = ''"
          @input="validate('formacao')"
          ladoIcone="direito"
          clickIcone
          colorPlaceholder="#9E9E9E"
          placeholder="Formação *"
          titulo="Formação"
        />
      </unicom-coluna>
      <unicom-coluna sm="3" :class="espacamentoMobile">
        <unicom-campo-texto
          v-model="diretorTecnico.cidade"
          :icone="diretorTecnico.cidade ? 'x' : ''"
          :mensagemErro="errors.cidade"
          @click-icone="diretorTecnico.cidade = ''"
          @input="validate('cidade')"
          ladoIcone="direito"
          clickIcone
          colorPlaceholder="#9E9E9E"
          placeholder="Cidade *"
          titulo="Cidade"
        />
      </unicom-coluna>
    </unicom-linha>

    <unicom-linha style="min-height: 76px">
      <unicom-coluna sm="3" :class="espacamentoMobile">
        <unicom-campo-texto
          v-model="diretorTecnico.telefone"
          :mask="['(##) ####-####']"
          :icone="diretorTecnico.telefone ? 'x' : ''"
          :mensagemErro="errors.telefone"
          @click-icone="diretorTecnico.telefone = ''"
          @input="validate('telefone')"
          maxCaracteres="14"
          ladoIcone="direito"
          clickIcone
          colorPlaceholder="#9E9E9E"
          placeholder="Telefone *"
          titulo="Telefone"
        />
      </unicom-coluna>
      <unicom-coluna sm="3" :class="espacamentoMobile">
        <unicom-campo-texto
          v-model="diretorTecnico.celular"
          :mask="['(##) #####-####']"
          :icone="diretorTecnico.celular ? 'x' : ''"
          :mensagemErro="errors.celular"
          @click-icone="diretorTecnico.celular = ''"
          @input="validate('celular')"
          maxCaracteres="15"
          ladoIcone="direito"
          clickIcone
          colorPlaceholder="#9E9E9E"
          placeholder="Celular *"
          titulo="Celular"
        />
      </unicom-coluna>
    </unicom-linha>
  </unicom-layout-cartao>
</template>

<script>
import DadosComplementaresDiretorTecnicoMixin from "@/views/RecursosPropriosQuestionarios/shared/mixins/questionarios/DadosComplementaresDiretorTecnicoMixin";

export default {
  mixins: [DadosComplementaresDiretorTecnicoMixin],
  data() {
    return {};
  },
  methods: {},
  computed: {
    /**
     * Verifica se a tela está no viewport mobile e se estiver, retorna uma classe que da o espaçamento para cima
     */
    espacamentoMobile() {
      return this.$breakpoint.smAndDown ? "mt-4" : "";
    }
  },
  watch: {}
};
</script>

<style scoped>
.linha-embaixo {
  padding-bottom: 24px;
  border-bottom: 1px solid #ebebeb;
  margin-bottom: 24px;
}
</style>
